import type React from 'react';
import User from '@/icons/User';
import Bookmark from '@/icons/Bookmark';
import BookOpen from '@/icons/BookOpen';
import FolderClosed from '@/icons/FolderClosed';
import NotebookTabs from '@/icons/NotebookTabs';
import { getSourceTypeLabel, SOURCE_TYPE_LABELS } from '@/i18n/labelMaps';

export { SOURCE_TYPE_LABELS, getSourceTypeLabel };

export const SOURCE_TYPES = ['person', 'website', 'publication', 'repository', 'other'] as const;

export type SourceType = (typeof SOURCE_TYPES)[number];

export type SourceTypeTone = 'quince' | 'teal' | 'forest' | 'bark' | 'neutral';

interface SourceTypeIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export interface SourceTypeMeta {
  label: string;
  Icon: React.FC<SourceTypeIconProps>;
  tone: SourceTypeTone;
}

export const SOURCE_TYPE_META: Record<SourceType, SourceTypeMeta> = {
  person: {
    get label() {
      return getSourceTypeLabel('person');
    },
    Icon: User,
    tone: 'quince'
  },
  website: {
    get label() {
      return getSourceTypeLabel('website');
    },
    Icon: Bookmark,
    tone: 'teal'
  },
  publication: {
    get label() {
      return getSourceTypeLabel('publication');
    },
    Icon: BookOpen,
    tone: 'forest'
  },
  repository: {
    get label() {
      return getSourceTypeLabel('repository');
    },
    Icon: FolderClosed,
    tone: 'bark'
  },
  other: {
    get label() {
      return getSourceTypeLabel('other');
    },
    Icon: NotebookTabs,
    tone: 'neutral'
  }
};

export function normalizeSourceType(type: string): SourceType {
  return SOURCE_TYPES.includes(type as SourceType) ? (type as SourceType) : 'other';
}
